import React from 'react';
import { InsightMetric, ComponentProps, FeedbackSource } from '../types.js';

/**
 * InsightMetrics - Platform Admin
 * 
 * RECOVERED FROM: /src/features/advanced/components/feedback/insights/components/InsightMetrics.tsx
 * MODIFICATIONS FOR PLATFORM ADMIN:
 * - No changes needed - component is presentation-only
 * - Displays aggregated metrics across all tenants
 * 
 * Following 00-READ-THIS-FIRST:
 * - SINGLE SOURCE OF TRUTH: Recovered original, not duplicated
 * - NO FUNCTIONAL DUPLICATES: This is the only InsightMetrics
 */

interface InsightMetricsProps extends ComponentProps {
  metrics: InsightMetric[];
  source: FeedbackSource;
}

export const InsightMetrics: React.FC<InsightMetricsProps> = ({
  metrics,
  source
}) => {
  const filteredMetrics = source === 'all' 
    ? metrics 
    : metrics.filter(m => m.source === source);

  const getTrendIndicator = (trend?: string) => {
    switch (trend) {
      case 'up':
        return '↑';
      case 'down':
        return '↓';
      default:
        return '→';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {filteredMetrics.map((metric, index) => (
        <div key={index} className="bg-gray-800/50 rounded-lg p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm text-gray-400">{metric.label}</p>
              <p className="text-2xl font-semibold mt-1">
                {/* ✅ Task 5: Show N/A for 0 values */}
                {metric.value === 0 ? 'N/A' : metric.value}
              </p>
              {metric.change !== undefined && metric.value !== 0 && (
                <p className="text-sm mt-1">
                  <span className={metric.trend === 'up' ? 'text-green-500' : 
                                 metric.trend === 'down' ? 'text-red-500' : 
                                 'text-gray-500'}>
                    {getTrendIndicator(metric.trend)} {metric.change > 0 ? '+' : ''}{metric.change}%
                  </span>
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
